export const STAGE_NAME = import.meta.env.VITE_STAGE_NAME ?? 'prod'
